import { Component, Input, OnInit } from '@angular/core';
import { GridCell } from '../../../models/sections-model';

@Component({
  selector: 'kw-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss']
})
export class AddToCartComponent implements OnInit {
  @Input() gridCell:GridCell;
  quantity:number = 1;
  constructor() { }

  ngOnInit(): void {
  }

}
